import { pie as d3_pie } from 'd3-shape'
import { convertRowsToData } from '../utils/dataUtils'
export default function PieDataController(rows, config, hiddenItems) {
  let propperHeaders = ['id', 'value']
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)

  if (hiddenItems) data = data.filter(d => hiddenItems.indexOf(d.id) < 0)

  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let diff = a.value - b.value
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }

  let total = data.reduce((sum, d) => sum + +d.value, 0)
  data = data.map(d => {
    let percent = (100 * d.value) / total
    //if (percent < 1) percent = '<1'
    return { ...d, percent: percent }
  })
  if (config.groupOthersThreshold > 0) {
    let threshold = (total * config.groupOthersThreshold) / 100
    let others = data.filter(d => d.value <= threshold)
    let notOthers = data.filter(d => d.value > threshold)
    if (others.length > 1) {
      data = notOthers.concat([
        {
          id: config.groupOthersLabel,
          value: others.reduce((sum, d) => sum + +d.value, 0),
          percent: others.reduce((sum, d) => sum + +d.percent, 0),
          othersData: others,
        },
      ])
    }
  }
  let minAngle = config.minSectorAngle ? (config.minSectorAngle / 180) * Math.PI : 0
  let minValue = (minAngle * total) / (2 * Math.PI)
  var pie = d3_pie()
    .value(d => Math.max(d.value, minValue))
    .padAngle(0.02)
    .sort(null)
  if (config.shape === 'half') pie.startAngle(-Math.PI / 2).endAngle(Math.PI / 2)
  let res = pie(data)
  res.forEach(d => (d.id = d.data.id))
  return res
  // return data.map((d,i)=>{
  //   if(!d.id) d.id = i
  //   return d
  // })
}
